import type { FaireProductEntity } from "../../entity_types/product";

export const p_z7fktr7rcu: FaireProductEntity = {
  token: "p_z7fktr7rcu",
  type: "product",
  name: "Gold Tiara Headband- Girls Dress Up Headband",
  brandToken: "b_gro99lye",
  brandName: "Sweet Wink",
  imageUrl:
    "https://cdn.faire.com/fastly/4c0a1688dbce4f1654c7331dd8f0a9f01a4a132ccba55a80bb185eb4a6cc071f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/279f94b209745e3e42b8f70dc45d84e82a009d035d8acbc8be43507b0092a2c9.jpeg",
    "https://cdn.faire.com/fastly/d47a022acc0d019e3ad6a24034515f620987726d0f6f3270e6dfdc3aecd4b35c.jpeg",
    "https://cdn.faire.com/fastly/992d80e5a2a21c916f8d5dbddecd47e65dd4f25e7d1b3af61ce91d8328df409e.jpeg",
    "https://cdn.faire.com/fastly/df6897b1209d0cec1cecd40e8a80e612ff11963f863dd6b984eb3b02c636f06d.jpeg",
    "https://cdn.faire.com/fastly/d033e6370da1d0564aa7d283c8510585c34b0e0a0553c2ec7d91076d5e39624c.jpeg",
    "https://cdn.faire.com/fastly/c740cc57f776a82e498ac87e018a6616fde290667c314aeef0e43d0fbb7f0e83.jpeg",
    "https://cdn.faire.com/fastly/5a7e1c07f2ed02f29ea82b88879a6c3c8aa5dc0430396a9d871da569dab8354a.jpeg",
  ],
  priceDollars: 7,
  description:
    "Every little girl needs the perfect headband to complete her look! The Gold Tiara Headband is the perfect hair accessory for celebrating a Birthday or for playing Dress Up.\n\n𝐅𝐞𝐚𝐭𝐮𝐫𝐞𝐬:\n• Gold glitter design\n• Satin lined headband\n• Glitter accents are “shed free”\n• One size fits all\n\nPair this headband with a matching Sweet Wink tutu and shirt for a complete head-to-toe outfit!",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-11T03:44:21.479Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
